import { featureFlagService } from '../../utils/feature-flag'
import API from '../commons/api'

export const defaultConverse = (input: {
  prompt: string
  history?: string
}) => {
  return API.functional.request('POST', '/api/v1/ai/default-converse', input)
}

export type AiTaskType = 'WBS_DECOMPOSITION' | 'AI_SCHEDULING'

export const determineAiTaskType = async (
  input: string
): Promise<AiTaskType | undefined> => {
  const response = await API.functional.request('GET', '/api/v1/ai/task/type', {
    input,
  })
  return response.json
}

export const taskDecomposition = (input: {
  wbsItemUuid: string
  wbsItemTitle: string
  wbsItemDescription: string
  prompt: string
  history?: string
  tasks?: string // 既存のWBSのタスクをカンマ区切りで渡す
  startDate?: string
  endDate?: string
  type?: string
  inputForScheduling?: {
    scheduledDateTermOfParent?: {
      startDate?: string
      endDate?: string
    }
    // TODO: wbsItemsという名前は適当ではないので変更する
    wbsItems?: {
      treeUuid?: string
      estimatedHour?: number
      assigneeName?: string
    }[]
  }
}) => {
  return API.functional.request('POST', '/api/v1/ai/task-decomposition', input)
}

export type AiChildWbsItemSchedulingOutput = {
  assigneeName: string
  schedule: {
    startDate: string
    endDate: string
  }
  estimatedHour: number
}
export type AiWbsItemSchdulingOutput = {
  treeUuid: string
  assigneeName: string
  schedule: {
    startDate: string
    endDate: string
  }
  children: AiChildWbsItemSchedulingOutput[]
}
export type AiSchedulingOutput = {
  answerText: string
  output: AiWbsItemSchdulingOutput[]
}
export const aiScheduling = async (input: {
  scheduledDateTermOfParent?: {
    startDate?: string
    endDate?: string
  }
  // TODO: wbsItemsという名前は適当ではないので変更する
  wbsItems?: {
    treeUuid?: string
    estimatedHour?: number
    assigneeName?: string
    childCount: number
  }[]
}): Promise<AiSchedulingOutput | undefined> => {
  const response = await API.functional.request(
    'POST',
    '/api/v1/ai/ai-scheduling',
    input
  )
  if (!response.json) {
    return undefined
  }
  return response.json as AiSchedulingOutput
}

export const isAiAvailable = () => {
  return featureFlagService.isEnabled('use-ai-feature')
}

export const isAiAgentAvailable = () => {
  return featureFlagService.isEnabled('use-ai-agent')
}

export type AiAgentConverseResponse = {
  conversationUuid: string
}

// UIが把握している画面文脈をエージェントに渡すための型。全フィールド任意（エージェント側は
// 未対応画面からの省略を前提に実装される）。詳細は ai-agent-context-design.md 参照。
export type PageContext = {
  screen: string
  project?: {
    code: string
    name: string
  }
  rootWbsItem?: {
    code: string
    name: string
    type: string
  }
}

/**
 * AIエージェントとの1ターンの会話を開始する。
 * 202 を返し、実際のトークンは STOMP の WebSocket 経由でストリーミングされる。
 * conversationUuid を null（未指定）で送信した場合、バックエンドが採番して返す。
 * 同一会話で既にストリーミング中のターンがある場合は 409 を返す。
 */
export const aiAgentConverse = async (input: {
  prompt: string
  conversationUuid?: string
  pageContext?: PageContext
}): Promise<AiAgentConverseResponse> => {
  // pageContext は指定時のみボディに含める（省略時は undefined のプロパティごと落とす）。
  const { pageContext, ...rest } = input
  const body = pageContext ? { ...rest, pageContext } : rest
  const response = await API.functional.request(
    'POST',
    '/api/v1/ai/agent/converse',
    body
  )
  return response.json as AiAgentConverseResponse
}

export type HelpChatResponse = {
  text: string
  sessionId: string
}

export const helpChat = async (input: {
  query: string
  sessionId?: string
}): Promise<HelpChatResponse> => {
  const response = await API.functional.request(
    'POST',
    '/api/v1/ai/help',
    input
  )
  return response.json as HelpChatResponse
}
